import { createAction } from 'redux/helpers/actions';
import types from './types';

export default {
  fetchSuperpowers: () => createAction(types.fetchSuperpowers),
  fetchSuperpowersSuccess: data => createAction(types.fetchSuperpowersSuccess, data),
  fetchSuperpowersFailure: error => createAction(types.fetchSuperpowersFailure, error),

  findMembers: data => createAction(types.findMembers, data),
  findMembersSuccess: data => createAction(types.findMembersSuccess, data),
  findMembersFailure: error => createAction(types.findMembersFailure, error),

  getMember: data => createAction(types.getMember, data),
  getMemberSuccess: data => createAction(types.getMemberSuccess, data),
  getMemberFailure: error => createAction(types.getMemberFailure, error),

  getDownloads: () => createAction(types.getDownloads),
  getDownloadsSuccess: data => createAction(types.getDownloadsSuccess, data),
  getDownloadsFailure: error => createAction(types.getDownloadsFailure, error),

  downloadFile: data => createAction(types.downloadFile, data),
  downloadFileSuccess: data => createAction(types.downloadFileSuccess, data),
  downloadFileFailure: data => createAction(types.downloadFileFailure, data),
};
